import * as account from "./auth";
export default {
  ...account,
};
